webpackJsonp([114276838955818,60335399758886],{

/***/ 122:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(248);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(122);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(39);
	
	__webpack_require__(40);
	
	var _anchorLinkJump = __webpack_require__(255);
	
	var _anchorLinkJump2 = _interopRequireDefault(_anchorLinkJump);
	
	var _Button = __webpack_require__(23);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Client = __webpack_require__(27);
	
	var _Client2 = _interopRequireDefault(_Client);
	
	var _Footer = __webpack_require__(28);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Form = __webpack_require__(29);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _HalfHero = __webpack_require__(30);
	
	var _HalfHero2 = _interopRequireDefault(_HalfHero);
	
	var _Header = __webpack_require__(31);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Hero = __webpack_require__(32);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _IconList = __webpack_require__(33);
	
	var _IconList2 = _interopRequireDefault(_IconList);
	
	var _Testimonial = __webpack_require__(34);
	
	var _Testimonial2 = _interopRequireDefault(_Testimonial);
	
	var _Testimonials = __webpack_require__(35);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'global-wrapper' },
	    _react2.default.createElement(_Header2.default, null),
	    children(),
	    _react2.default.createElement(
	      _Form2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Get Started Today!'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Fill out this short form to start your personalized transformation!'
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, null),
	    (0, _anchorLinkJump2.default)()
	  );
	};
	// import menu from '../scripts/menu.js';
	

	module.exports = exports['default'];

/***/ }),

/***/ 255:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function () {
	  // The function actually applying the offset
	
	  if (typeof window !== 'undefined') {
	    var offsetAnchor = function offsetAnchor() {
	      if (location.hash.length !== 0) {
	        window.scrollTo(window.scrollX, window.scrollY - 100);
	      }
	    };
	
	    // This will capture hash changes while on the page
	
	
	    window.addEventListener("hashchange", offsetAnchor);
	
	    // This is here so that when you enter the page with a hash,
	    // it can provide the offset in that case too. Having a timeout
	    // seems necessary to allow the browser to jump to the anchor first.
	    window.setTimeout(offsetAnchor, 1);
	  }
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-df295bfc0c2493f9fbb0.js